module.exports = __webpack_public_path__ + "static/media/DT10.c8c4770d.jpg";